import { Joi, objectSchemaOf } from '../helpers';

export const saveBotMessageParamsSchema = objectSchemaOf<ISaveBotMessageParams>(
  {
    message: Joi.string().required(),
    messageId: Joi.string().required(),
    conversationId: Joi.string().required(),
    timestamp: Joi.number().required(),
  }
);

export interface ISaveBotMessageParams {
  message: string;
  messageId: string;
  conversationId: string;
  timestamp: number;
}
